<template>
  <section class="course-container section columns" v-if="course">
    <!-- <aside class="container aside column is-one-fifth course-title-box has-text-left">
      <h1 class="course-name title has-text-left is-4">{{ course.name }}</h1>

      <button class="button gen-button" @click="downloadFiles">{{ buttonText }}</button>
    </aside>-->
    <div class="column container is-fluid courses-entry has-text-left">
      <div class="courses-entry-title" v-if="course.requirements.length > 0">
        <h1>Requirements</h1>
        <p>{{ course.requirements }}</p>
      </div>
      <div class="courses-overview-title box" v-if="course.content.length > 0">
        <h1>Overview</h1>
        <span class="overview-content" v-html="course.content"></span>
      </div>
      <div class="courses-entry-title box">
        <h1>Course</h1>
        <div class="courses-entry-xdeulu5o41">
          <div
            class="courses-entry-xdeulu5o41-modules"
            v-for="(unit, index) in course.modules"
            :key="index"
          >
            <h5>
              <span>{{ unit.name }}</span>
              <i class="fa fa-plus"></i>
            </h5>
            <div class="courses-entry-modules-lessons-block active">
              <ul class="courses-entry-modules-lessons">
                <li v-for="(lesson, i) in unit.lessons" :key="i">
                  <a
                    :class="{'completed' : $store.state.auth.user.completedLessons.find(e => e.id === lesson.id)}"
                    @click.prevent="gotoLesson(courseId, unit.id, lesson.id)"
                  >{{ lesson.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CourseClient } from "../../clients/CourseClient";
import BaseHelper from "../../helpers/BaseHelper";

export default {
  props: ["courseId"],

  mixins: [BaseHelper],

  data() {
    return {
      course: null,
      selectedList: null,
      buttonText: "Download all assets",
      assetsPath: null,
      selectedUnit: null
    };
  },

  methods: {
    toggleSelection(index) {
      if (this.selectedUnit == index) {
        this.selectedUnit = null;
      } else {
        this.selectedUnit = index;
      }
    },
    getCourse() {
      this.$store.dispatch("loader/show", "Fetching course....");
      CourseClient.getCourse(this.courseId)
        .then(response => {
          this.course = response.data.course;
          this.$store.dispatch("loader/hide");
        })
        .catch(err => {
          this.$store.dispatch("loader/hide");
        });
    },

    downloadFiles() {
      if (this.assetsPath !== null) {
        return (window.location = this.assetsPath);
      }

      this.$store.dispatch("loader/show", "Packing resources....");
      CourseClient.downloadFiles()
        .then(response => {
          this.$store.dispatch("loader/hide");
          let fileLocation = response.data.file;
          if (fileLocation !== null) {
            this.assetsPath = fileLocation;
            this.buttonText = "Click to download assets now.";
          }
        })
        .catch(() => {
          this.$store.dispatch("loader/hide");
        });
    }
  },

  created() {
    this.getCourse();
  }
};
</script>
<style lang='scss' scoped>
@import "../../assets/scss/variables.scss";

@import "../../assets/scss/courses/entry.scss";
</style>